<template>
  <div>
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2>Vehicle Types</h2></v-toolbar-title>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field>
    </v-toolbar>

    <!-- Datatable hidden while data is loading -->
    <div v-if="!loading">
      <!-- Datatable --> 
      <v-data-table
          :headers="headers"
          :items="vehicleTypeData"
          :search="search"
          class="elevation-1">
        <!-- Row action (edit/delete) -->
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>

      <br/>

      <!-- Load More button -->
      <!--<v-btn v-on:click="loadMore">More</v-btn>-->

      <!-- Driver Dialog (create/edit) -->
      <v-dialog
          v-model="dialog"
          max-width="500px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              class="mt-1,5 ml-2"
              v-bind="attrs"
              v-on="on"
          >
            New Item
          </v-btn>
        </template>
        <CreateDialog
            v-bind:close-function="closeDialog"
            v-bind:form-title="dialogTitle"
            v-bind:item="editVehicle"
            v-bind:save-function="saveVehicle" />
      </v-dialog>

      <!-- Delete confirmation dialog -->
      <v-dialog v-model="deleteDialog" max-width="500px">
        <DeleteDialog
          v-bind:close-delete="closeDialog"
          v-bind:delete-item-confirm="deleteVehicle">
          </DeleteDialog>
      </v-dialog>
    </div>

    <!-- Display loader when fetching data -->
    <div v-if="loading">
      <Loading/>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import CreateDialog from "@/components/vehicle-type/CreateDialog";
import DeleteDialog from "@/components/vehicle-type/DeleteDialog";
import { doc, getFirestore, addDoc, collection, getDocs, deleteDoc, setDoc, limit, startAfter }from "firebase/firestore";
const db = getFirestore();

async function cleanupAfterDialog(context) {
  context.editVehicle = {};
  context.query = null;
  context.vehicleTypeData = [];
  await context.loadMore();
  context.closeDialog();
}

export default {

  name: 'vehicleType',
  components: {DeleteDialog, CreateDialog, Loading },

  data() {
    return {
      dialog: false,
      dialogTitle: 'New Vehicle Type',
      deleteDialog: false,
      editVehicle: {},
      headers: [
        { text: 'Unique Id', value: 'key' },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type'},
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      vehicleTypeData: [],
      options: {
        page: 1,
        pageSize: 10
      },
      loading: false,
      query: null,
      lastVisible: null,
      search: '',
    }
},

methods: {
    closeDialog() {
      this.dialog = false;
      this.deleteDialog = false;
      this.dialogTitle = 'New Vehicle Type';

      this.editWaste = {};
    },

    async saveVehicle() {
      if (!this.editVehicle.id) {
        addDoc(collection(db, 'vehicle-types'), this.editVehicle)
        .then( async () => {
          await cleanupAfterDialog(this);
        });
      } 
      else {
        setDoc(doc(db, 'vehicle-types', this.editVehicle.id), this.editVehicle, { merge: true })
        .then( async () => {
          await cleanupAfterDialog(this);
        });
      }
      this.dialog = false;
    },
    async deleteVehicle() {
      deleteDoc(doc(db, 'vehicle-types', this.editVehicle.id))
      .then( async () => {
        await cleanupAfterDialog(this);
      });
    },
    async editItem(vehicleType) {
      Object.assign(this.editVehicle, vehicleType);
      this.dialogTitle = "Edit Vehicle Type";
      this.dialog = true;
    },
    async deleteItem(vehicleType) {
      Object.assign(this.editVehicle, vehicleType);
      this.deleteDialog = true;
    },
    mapData(vehicleType, vehicleTypeId) {
      return {
        id: vehicleTypeId,
        type: vehicleType.type,
        name: vehicleType.name,
        key: vehicleType.key,
      }
    },

    async getNextData(options) {
      this.loading = true;
      this.options = options;
      const { pageSize } = options;
      if (!this.query) {
        this.query = getDocs(collection(db, 'vehicle-types'), limit(pageSize));
      }
      const currentQuery = this.query;
      currentQuery
          .then((snapshot) => {
            this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
            if (!this.vehicleTypeData) {
              this.vehicleTypeData = [];
            }
            snapshot.forEach((res) => {
              this.vehicleTypeData.push(this.mapData(res.data(), res.id));
            });
            this.query = getDocs(collection(db, 'vehicle-types'), startAfter(this.lastVisible), limit(pageSize));
            this.loading = false;
          })
          .catch(e => {
            console.log(e);
            this.loading = false;
          });
    },

    async loadMore() {
      await this.getNextData(this.options);
    }
  },
  async mounted() {
    if (this.vehicleTypeData.length === 0) {
      await this.getNextData(this.options);
    }
  }
}

</script>

<style scoped>

</style>